export const getClientId = () => {
  const existing = localStorage.getItem('kafel-lab-client-id');
  if (existing) return existing;
  const clientId = crypto.randomUUID();
  localStorage.setItem('kafel-lab-client-id', clientId);
  return clientId;
};

export const clientHeaders = (withContentType = false): HeadersInit => ({
  'x-kafel-client-id': getClientId(),
  ...(withContentType ? { 'Content-Type': 'application/json' } : {}),
});
